import { qsa } from './util';

jQuery(window).on('scroll', function() {
  if (
    $(window).scrollTop() >= $('#desktopTabs').offset().top &&
    $(window).scrollTop() <= $('#section8').offset().top
  ) {
    $('#tabs-digital').addClass('sticky');
  } else {
    $('#tabs-digital').removeClass('sticky');
  }
});
$(document).ready(function() {
  //slick
  $('.slick.marquee').slick({
    speed: 5000,
    autoplay: true,
    autoplaySpeed: 0,
    centerMode: true,
    cssEase: 'linear',
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    infinite: true,
    initialSlide: 1,
    arrows: false,
    buttons: false
  });
  //toggle the component with class accordion_body
  $('.accordion_head').click(function() {
    $('html, body').animate(
      {
        scrollTop: $('#MobileAccordian').offset().top
      },
      0
    );

    if ($('.accordion_body').is(':visible')) {
      $('.accordion_body').slideUp(100);
      $('.plusminus').text('+');
    }
    if (
      $(this)
        .next('.accordion_body')
        .is(':visible')
    ) {
      $(this)
        .next('.accordion_body')
        .slideUp(100);
      $(this)
        .children('.plusminus')
        .text('+');
    } else {
      $(this)
        .next('.accordion_body')
        .slideDown(100);
      $(this)
        .children('.plusminus')
        .text('-');
    }
  });
});

let menuSection = qsa('#tabs-digital li a');

// for clickable event
menuSection.forEach(v => {
  v.onclick = () => {
    setTimeout(() => {
      menuSection.forEach(j => j.classList.remove('activeTab'));
      v.classList.add('activeTab');
    }, 300);
  };
});

// // for window scrolldown event

window.onscroll = () => {
  let mainSection = qsa('.onepage-content');

  mainSection.forEach((v, i) => {
    let rect = v.getBoundingClientRect().y;
    if (rect < 200) {
      console.log();
      menuSection.forEach(v => v.classList.remove('activeTab'));
      menuSection[i].classList.add('activeTab');
    }
  });
};
